import styled from '@emotion/styled';

export const Button = styled.button`
  height: 3.4rem;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  & > img {
    height: 100%;
  }
`;
